import { render } from "./Patient.vue?vue&type=template&id=3c361e0c&scoped=true"
import script from "./Patient.vue?vue&type=script&lang=js"
export * from "./Patient.vue?vue&type=script&lang=js"

import "./Patient.vue?vue&type=style&index=0&id=3c361e0c&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c361e0c"]])

export default __exports__